import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {useAppSelector} from '@/hooks';
import type {UserSaveConflictPopupProps} from '@Components/user-save-conflict-popup';

const PANEL_ID = 'user-campaign-sending-options-panel';

export interface UserSaveConflictModalProps extends UserSaveConflictPopupProps {
  /** The user closed the dialog (panel close, Escape or overlay) without choosing either version. */
  onDismiss?: VoidFunction;
}

export default function UserSaveConflictModal(): ReactElement<any> {
  const panelProps = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.USER_SAVE_CONFLICT_MODAL].panelProps as UserSaveConflictModalProps;
  });

  const height = 'fit-content';
  const width = '100%';
  const maxWidth = '500px';
  const maxHeight = 'fit-content';

  return (
    <Modal
      modalId={MODALS_IDS.USER_SAVE_CONFLICT_MODAL}
      showNonFunctionalDragHandle
      modalMaxHeight={maxHeight}
      modalHeight={height}
      modalMaxWidth={maxWidth}
      panelId={PANEL_ID}
      modalWidth={width}
      onDismiss={panelProps.onDismiss}
    >
      <LazyPanel
        panelDirectoryName="user-save-conflict-panel"
        panelProps={{
          ...panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openUserSaveConflictModal = (props: UserSaveConflictModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.USER_SAVE_CONFLICT_MODAL,
      panelProps: props,
    })
  );
};
